export default __webpack_public_path__ + "static/media/red-frame-gradient.9822af35.svg";